import { MyContext } from "../../components/context/Context";
import React, { useState, useEffect, useContext } from "react";

import "../../style/sidebar-usuario.css";
import iconoProfile from "../../images/profile.svg";
import iconoPuntos from "../../images/points.svg";
import iconoMixologia from "../../images/mixologia.svg";
import iconShoppingBag from "../../images/shopping_bag.svg";
import iconHistory from "../../images/history.svg";
import iconAccount from "../../images/account_24.svg";
import Arrow from "../../images/arrowright.svg";

import { Link } from "react-router-dom";
import { NavBar } from "../../components/NavBar";

function SidebarUsuarioMobile() {
  const { puntosActuales, logout } = useContext(MyContext);

  const salir = () => {
    logout();
    sessionStorage.clear();
    sessionStorage.setItem("activo", true);
    window.location.href = "/Login";
  };

  const menuItems = [
    {
      path: "/datos",
      name: "Datos Personales",
      icon: iconoProfile,
    },
    {
      path: "/sumar-puntos",
      name: "Sumar puntos",
      icon: iconoPuntos,
    },
    {
      path: "/mis-pedidos",
      name: "Mis pedidos",
      icon: iconShoppingBag,
    },
    {
      path: "/historial-compra",
      name: "Historial de compra",
      icon: iconHistory,
    },
  ];

  const [selectedItem, setSelectedItem] = useState(null);

  const handleClickItems = (index) => {
    console.log(index + "selected");
    setSelectedItem(index);
  };

  return (
    <>
      <NavBar />
      <div className="main-div2 h-100  ">
        <div className="account-section">
          <img src={iconAccount} />
          <h5>
            {sessionStorage.getItem("userName")}{" "}
            {sessionStorage.getItem("userLastName")}
          </h5>
        </div>
        <div className="puntos-section">
          <Link to="/datosPersonales/historial-compra">
            <p>{puntosActuales} puntos</p>
          </Link>
        </div>
        <hr />
        {menuItems.map((element, index) => (
          <Link to={element.path === "/sumar-puntos" ? "/sumar-puntos" : "/datosPersonales" + element.path} key={index}>
            <div className="d-flex align-items-center justify-content-between">
              <div
                key={index}
                className={`sidebar-items-list col-10 ${
                  selectedItem == index ? "selected" : ""
                }`}
                onClick={() => handleClickItems(index)}
              >
                <img src={element.icon} />
                <h5>{element.name}</h5>
              </div>
              <div className="px-2 col-2">
                <img src={Arrow} alt="" />
              </div>
            </div>
          </Link>
        ))}
        <hr />
        <div className="sidebar-logout" onClick={salir}>
          <h5>Cerrar sesión</h5>
        </div>
      </div>
    </>
  );
}

export default SidebarUsuarioMobile;
